module.exports = __webpack_public_path__ + "img/profile.b89c82e8.svg";